// #region Imports

import { adjustHue, hexToHSL, hslToHex } from '../common';

// #endregion

/**
 * Generate a triadic color palette
 * @param baseHex
 * @param adjustment
 * @returns
 */
export function generateTriadicPalette(baseHex: string, adjustment: number): Record<string, string> {
    const baseHSL = hexToHSL(baseHex);
    const triadicHSL = adjustHue(baseHSL, adjustment);
    const palette: Record<string, string> = {};

    // Define the steps
    const steps = [
        0,
        50,
        100,
        200,
        300,
        400,
        500,
        600,
        700,
        800,
        900
    ];

    steps.forEach((step) => {
        let [h, s, l]: [number, number, number] = triadicHSL;

        if (step === 0) {
            l = 1; // White
        } else {
            // Gradually decrease lightness for other steps
            l = 1 - (step / 1000);
        }

        palette[`${step}`] = hslToHex(h, s, Math.max(0, Math.min(1, l)));
    });

    return palette;
}

/**
 * Generate a single triadic color
 * @param baseHex
 * @param adjustment
 * @returns
 */
export function generateTriadicColor(baseHex: string, adjustment: number): string {
    const baseHSL = hexToHSL(baseHex);
    const triadicHSL = adjustHue(baseHSL, adjustment);
    const [h, s]: [number, number, number] = triadicHSL;
    // Use step 500 lightness (0.5) to match palette base
    return hslToHex(h, s, 0.5);
}
